/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Map principals to roles
 * @export
 * @interface NewRoleMapping
 */
export interface NewRoleMapping {
    /**
     * The principal type, such as USER, APPLICATION, ROLE, or user model name in case of multiple user models
     * @type {string}
     * @memberof NewRoleMapping
     */
    principalType?: string;
    /**
     * 
     * @type {number}
     * @memberof NewRoleMapping
     */
    principalId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewRoleMapping
     */
    roleId?: number;
}

/**
 * Check if a given object implements the NewRoleMapping interface.
 */
export function instanceOfNewRoleMapping(value: object): value is NewRoleMapping {
    return true;
}

export function NewRoleMappingFromJSON(json: any): NewRoleMapping {
    return NewRoleMappingFromJSONTyped(json, false);
}

export function NewRoleMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRoleMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'principalType': json['principalType'] == null ? undefined : json['principalType'],
        'principalId': json['principalId'] == null ? undefined : json['principalId'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
    };
}

export function NewRoleMappingToJSON(json: any): NewRoleMapping {
    return NewRoleMappingToJSONTyped(json, false);
}

export function NewRoleMappingToJSONTyped(value?: NewRoleMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'principalType': value['principalType'],
        'principalId': value['principalId'],
        'roleId': value['roleId'],
    };
}

